import { render } from "./AppointmentDetails.vue?vue&type=template&id=d20d6890&scoped=true"
import script from "./AppointmentDetails.vue?vue&type=script&lang=js"
export * from "./AppointmentDetails.vue?vue&type=script&lang=js"

import "./AppointmentDetails.vue?vue&type=style&index=0&id=d20d6890&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d20d6890"]])

export default __exports__